import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "sms-campaigns-details" };
const _hoisted_2 = { class: "sms-campaigns-details__title" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "*", -1);
const _hoisted_4 = { class: "sms-campaigns-details__container" };
const _hoisted_5 = { class: "sms-campaigns-details__input" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "*", -1);
const _hoisted_7 = ["placeholder"];
const _hoisted_8 = { class: "sms-campaigns-details__input" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "*", -1);
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1);
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = ["innerHTML"];
import { ref, computed, watch } from 'vue';
import { debounce } from 'lodash';
import { useStore } from 'vuex';
import { fetchAudiences } from '@/features/SMSCampaigns/data';
import { whatsappLink } from '@/features/SMSCampaigns/utils';
import { mixpanelSmsCampaign } from '@/utilities/mixpanel/smsCampaigns';
import { formatNumber } from '@/utilities/formatters';
import { hasInvalidSpecialCharacters } from '@/utilities/validators/verifySpecialCharacters';
import vSelect from 'vue-select';
import Alert from '@/components/_atoms/Alert.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SMSCampaignsDetails',
    setup(__props) {
        const store = useStore();
        const campaignNameIsInvalid = ref(false);
        const hasAnyAudience = ref(null);
        const audienceList = ref([]);
        const loadingAudiences = ref(false);
        const balance = computed(() => store.state.smsCampaigns.balance);
        const audienceIsInvalid = computed(() => audience.value?.count === 0);
        const campaignName = computed({
            get: () => store.state.smsCampaigns.campaignName,
            set: name => store.commit('smsCampaigns/SET_CAMPAIGN_NAME', name),
        });
        const audience = computed({
            get: () => store.state.smsCampaigns.audience,
            set: value => store.commit('smsCampaigns/SET_AUDIENCE', value),
        });
        const hasInsufficientBalance = computed(() => audience.value?.count > balance.value);
        const fetchAudiencesList = (term = '', isInitialFetch = false) => {
            loadingAudiences.value = true;
            fetchAudiences(term)
                .then(audiences => {
                audienceList.value = audiences.data;
                if (isInitialFetch && hasAnyAudience.value === null) {
                    hasAnyAudience.value = audiences.data.length > 0;
                }
            })
                .finally(() => {
                loadingAudiences.value = false;
            });
        };
        const searchAudience = debounce((term) => {
            if (term)
                fetchAudiencesList(term);
        }, 500);
        fetchAudiencesList('', true);
        const verifySpecialCharacters = () => {
            campaignNameIsInvalid.value = hasInvalidSpecialCharacters(campaignName.value);
        };
        watch([campaignNameIsInvalid, () => audience.value?.count], ([campaignInvalid, audienceCount]) => {
            const audienceInvalid = audienceCount === 0;
            const hasInvalid = campaignInvalid || audienceInvalid;
            store.commit('smsCampaigns/SET_HAS_INVALID_FIELDS', { key: 'details', value: hasInvalid });
        });
        return (_ctx, _cache) => {
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            const _component_el_popover = _resolveComponent("el-popover");
            const _component_router_link = _resolveComponent("router-link");
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("strong", _hoisted_2, [
                    _createTextVNode(_toDisplayString(_ctx.$t('sms-campaigns.details.title')) + " ", 1),
                    _hoisted_3
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("strong", null, [
                            _createTextVNode(_toDisplayString(_ctx.$t('sms-campaigns.details.name')) + " ", 1),
                            _hoisted_6
                        ]),
                        _createVNode(_component_el_tooltip, {
                            visible: campaignNameIsInvalid.value,
                            "raw-content": true,
                            content: _ctx.$t('audiences.error-characters-name'),
                            placement: "right",
                            offset: 14,
                            "popper-class": "el--tooltip-error sms-campaigns-details__input--tooltip"
                        }, {
                            default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((campaignName).value = $event)),
                                    onInput: verifySpecialCharacters,
                                    type: "text",
                                    name: "name",
                                    placeholder: _ctx.$t('sms-campaigns.details.name-placeholder'),
                                    class: _normalizeClass({
                                        'sms-campaigns-details__input--error': campaignNameIsInvalid.value,
                                    })
                                }, null, 42, _hoisted_7), [
                                    [_vModelText, campaignName.value]
                                ])
                            ]),
                            _: 1
                        }, 8, ["visible", "content"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", null, [
                            _createElementVNode("strong", null, [
                                _createTextVNode(_toDisplayString(_ctx.$t('sms-campaigns.details.audience')) + " ", 1),
                                _hoisted_9
                            ]),
                            _createVNode(_component_el_popover, {
                                trigger: "hover",
                                effect: "dark",
                                placement: "top",
                                width: 280
                            }, {
                                reference: _withCtx(() => [
                                    _hoisted_11
                                ]),
                                default: _withCtx(() => [
                                    _createElementVNode("p", {
                                        innerHTML: _ctx.$t('sms-campaigns.details.tooltip-audience')
                                    }, null, 8, _hoisted_10)
                                ]),
                                _: 1
                            })
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_unref(vSelect), {
                            modelValue: audience.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((audience).value = $event)),
                            label: "name",
                            options: audienceList.value,
                            placeholder: _ctx.$t('select'),
                            loading: loadingAudiences.value,
                            clearable: false,
                            searchable: hasAnyAudience.value,
                            class: _normalizeClass({
                                'sms-campaigns-details__select--error': audienceIsInvalid.value,
                            }),
                            onSearch: _unref(searchAudience)
                        }, {
                            "open-indicator": _withCtx(({ attributes }) => [
                                _createElementVNode("span", _mergeProps(attributes, { class: "arrow-down" }), null, 16)
                            ]),
                            "no-options": _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('no-results')), 1)
                            ]),
                            _: 1
                        }, 8, ["modelValue", "options", "placeholder", "loading", "searchable", "class", "onSearch"])), [
                            [
                                _directive_tooltip,
                                {
                                    content: _ctx.$t('sms-campaigns.details.tooltip-error-audience'),
                                    theme: 'error',
                                    html: true,
                                    distance: 14,
                                    autoHide: false,
                                    shown: audienceIsInvalid.value,
                                },
                                void 0,
                                { right: true }
                            ]
                        ]),
                        (audience.value?.name)
                            ? (_openBlock(), _createElementBlock("small", {
                                key: 0,
                                class: "suggestion-details-header__section__text-audience",
                                innerHTML: _ctx.$tc('sms-campaigns.details.message-audience', { count: _unref(formatNumber)(audience.value?.count) })
                            }, null, 8, _hoisted_12))
                            : _createCommentVNode("", true)
                    ])
                ]),
                (!loadingAudiences.value && !hasAnyAudience.value)
                    ? (_openBlock(), _createBlock(Alert, {
                        key: 0,
                        type: "warning"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("span", {
                                innerHTML: _ctx.$t('sms-campaigns.details.alert-warning')
                            }, null, 8, _hoisted_13),
                            _createVNode(_component_router_link, {
                                to: "/base-management/base-audiences/create",
                                onClick: _cache[2] || (_cache[2] = ($event) => (_unref(mixpanelSmsCampaign).createAudience()))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('sms-campaigns.details.create-audience')), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (hasInsufficientBalance.value)
                    ? (_openBlock(), _createBlock(Alert, {
                        key: 1,
                        onLinkClick: _cache[3] || (_cache[3] = ($event) => (_unref(mixpanelSmsCampaign).buySms('audience'))),
                        type: "error",
                        message: _ctx.$t('sms-campaigns.details.alert-error', {
                            people: _unref(formatNumber)(audience.value?.count),
                            balance: _unref(formatNumber)(balance.value),
                            link: _unref(whatsappLink),
                        })
                    }, null, 8, ["message"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
